import { ConfigModel } from '@ibe/services';

class YsnConfigModel extends ConfigModel {
  hideCreateQuotationBookingButton?: boolean;
  enableMultipleRooms?: boolean;
  showDirectFlightsFilter?: boolean;
  affiliateAgencyNumber?: number;
  showAgencyCommunication?: boolean;
  displayStrikeThroughPrices?: boolean;
  maxDaysInDayRangeMultiRoomSearch?: number;
  context?: string;
  frontendCache?: {
    ttl: number;
    enable: boolean;
    filteredResultsMaxSize: number;
  };
}

export default YsnConfigModel;
